export const booker = $state({
  bWasAskedToLogin: false,
  bDidLoginFail: false,
  bIsLoggedInLockForm: false, // op dit moment locken we niet maar kun je na inloggen aanpassen in insturen (en daarmee overschrijven)
  bIsThereARemoteAcountWithCurrentEmail: false,
  bWantsAccount: false,
  bWantsDinner: false,
  bStayLoggedIn: false,
  bInsurance: false,
  bNewsletter: false,
  bNewsletterIsSubscribed: false,
  bTerms: false,
  sLastRemoteCheckedEmailAddress: '',
  bHasBadenkaartDayCredit: false,
  bHasBadenkaartShortCredit: false,
  iRelationID: false,
  sNewAccountPassword: '',
  sTitle: '',
  sName1: '',
  sName2: '',
  sName3: '',
  sEmail: '',
  sTel: '',
  sPostalcode: '',
  sHouse1: '',
  sHouse2: '',
  sStreet: '',
  sTown: '',
  sCountry: 'nl',
  sComments: '',
  aAllowedPaymentMethods: [],
  sPaymentMethod: false,
  sPaymentBrand: '',
  // sTitlePreset: '',
  // sName1Preset: '',
  // sName2Preset: '',
  // sName3Preset: '',
  // sEmailPreset: '',
  // sTelPreset: '',
  // sPostalcodePreset: '',
  // sHouse1Preset: '',
  // sHouse2Preset: '',
  // sStreetPreset: '',
  // sTownPreset: '',
  // sCommentsPreset: '',
  sGiftCardCode: false
});

window.hmk_booker = () => {
  console.log($state.snapshot(booker))
}

